const { adminCall } = require("./_utils");

module.exports = {
  draft: projectUid => adminCall("role.draft", {projectUid}),
  create: data => adminCall("role.create", data),
  modify: data => adminCall("role.modify", data),
  remove: uid => adminCall("role.remove", {uid})
}
